import { Table, Button, Space, Card } from 'antd';
import { userdata } from '../typing/table_typing';
import { Component } from 'react';
import { cardmargin, grayheader } from '../../CSSReferences';
import { Link } from 'react-router-dom';

export interface TableThingyMainProps{
  data:{
    user:userdata[],
  }
  onLoadRequested:()=>void;
  deactivateUser:(uuid:string)=> void;
}

interface TableThinyViewInnerState{filteredInfo:any, sortedInfo:any}

export class TableThingyView extends Component<TableThingyMainProps, TableThinyViewInnerState> 
{
    constructor(props:TableThingyMainProps){
      super(props);
      this.state = {
        filteredInfo: null,
        sortedInfo: null,
      };
    }

    deactivateUser(uuid:string){
      this.props.deactivateUser(uuid);
    };

    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 2000);
      
      // this.props.onButtonClicked();
    }

    data = this.props.data;
    
    handleChange = (pagination:any, filters:any, sorter:any) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    
      clearFilters = () => {
        this.setState({
        filteredInfo: null,
      });
      };
    
      clearAll = () => {
        this.setState({
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'age',
          },
        });
      };
    

render(){
  let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columns = [
      {
        title: 'User',
        dataIndex: 'username',
        key: 'username',
        // filters: [
        //   { text: 'Joe', value: 'Joe' },
        //   { text: 'Jim', value: 'Jim' },
        // ],
        // filteredValue: filteredInfo.username || null,
        // onFilter: (value:any, record:any) => record.username.includes(value),
        sorter: (a:any, b:any) => a.username.length - b.username.length,
        sortOrder: sortedInfo.columnKey === 'username' && sortedInfo.order,
        ellipsis: true,
        render: (col:string, row:any) => {
          if (row.active === false){
          return(
          <span style={{"color":"red"}} >[INACTIVE] {row.username} </span>
        );
        }
        else
        {
          return(
            <span style={{"color":"black"}} >{row.username}</span>
          );
        }
       },
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'uuid',
        sorter: (a:any, b:any) => a.name - b.name,
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'E-Mail',
        dataIndex: 'email',
        key: 'uuid',
        // filters: [
        // ],
        // filteredValue: filteredInfo.email || null,
        // onFilter: (value:any, record:any) => record.address.includes(value),
        sorter: (a:any, b:any) => a.email.length - b.email.length,
        sortOrder: sortedInfo.columnKey === 'email' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Role',
        dataIndex: 'role',
        key: 'uuid',
        sorter: (a:any, b:any) => a.role - b.role,
        sortOrder: sortedInfo.columnKey === 'role' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: 'Action',
        dataIndex: 'uuid',
        key: 'uuid',
        // filters: [
        // ],
        ellipsis: true,
        render: (col:string, row:any) => {
          if (row.active === false){
          return(
            <div>
              <Button ><Link to={"/Users/"+row.uuid}> Details</Link></Button>
              <Button onClick={() => {this.deactivateUser(row.uuid)}}> Activate</Button>
            </div>
          );
        }
        else
        {
          return(
            <div>
              <Button ><Link to={"/Users/"+row.uuid}> Details</Link></Button>
              <Button danger onClick={() => {this.deactivateUser(row.uuid)}}> Deactivate</Button>
            </div>
          );
        }
      }
      }
    ];

    
  return (
    <div>
      <Card title="Userlist" style={cardmargin}  hoverable styles={{ header: grayheader }}>
    <Space style={{ marginBottom: 16 }}>
    </Space>
    <Table columns={columns} dataSource={this.props.data.user} onChange={this.handleChange} />
    </Card>
    </div>
  )}
}